import { useNavigate } from "react-router-dom";
import "./DuplicateActiveEngagementModal.css";

const COPY =
  "An active booking already exists for this patient during the selected date and time. If you wish to change the caregiver, please use the Replace Caregiver or Reschedule option available in the existing booking.";

export default function DuplicateActiveEngagementModal({
  open,
  existingBookingId,
  onClose,
}) {
  const navigate = useNavigate();
  if (!open) return null;
  const bookingId = existingBookingId ? String(existingBookingId) : "";

  function goExisting() {
    if (bookingId) navigate(`/my-bookings?bookingId=${encodeURIComponent(bookingId)}`);
    else navigate("/my-bookings");
    onClose?.();
  }

  function goReplace() {
    if (bookingId) {
      navigate(`/my-bookings?bookingId=${encodeURIComponent(bookingId)}&action=replace`);
    } else {
      navigate("/my-bookings");
    }
    onClose?.();
  }

  function goReschedule() {
    if (bookingId) {
      navigate(`/my-bookings?bookingId=${encodeURIComponent(bookingId)}&action=reschedule`);
    } else {
      navigate("/my-bookings");
    }
    onClose?.();
  }

  return (
    <div className="dup-engagement" role="dialog" aria-modal="true" aria-labelledby="dup-engagement-title">
      <div className="dup-engagement__card">
        <h2 id="dup-engagement-title">Active booking already exists</h2>
        <p>{COPY}</p>
        <div className="dup-engagement__actions">
          <button type="button" className="dup-engagement__btn dup-engagement__btn--primary" onClick={goExisting}>
            View Existing Booking
          </button>
          <button type="button" className="dup-engagement__btn" onClick={goReplace}>
            Replace Caregiver
          </button>
          <button type="button" className="dup-engagement__btn" onClick={goReschedule}>
            Reschedule Booking
          </button>
          <button type="button" className="dup-engagement__btn dup-engagement__btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export function isDuplicateActiveEngagementError(err) {
  const code = String(err?.code || err?.data?.code || "").toUpperCase();
  const message = String(err?.message || "");
  return code === "DUPLICATE_ACTIVE_ENGAGEMENT" || message.includes("active booking already exists");
}
